import axiosInstance from "../../core/axiosConfig.ts";

export type City = {
    id: number;
    name: string;
    countryCode: string;
    latitude: number;
    longitude: number;
    isActive: boolean;
    /** Restaurants a customer would find there right now — zero means the market is not ready. */
    restaurantCount: number;
};

export class LocationService {
    async getLocationTypes(language: string = "ENG") {
        const response = await axiosInstance.get(
            '/location/type/list',
            { params: { language }, }
        );
        return response.data;
    }

    async getLocations(language: string = "ENG") {
        const response = await axiosInstance.get(
            '/location/list',
            { params: { language }, }
        );
        return response.data;
    }

    /**
     * Every city, including those still being prepared for launch.
     *
     * The admin list rather than the customer one on purpose: a restaurant has
     * to be assignable to a city before that city is switched on, which is how
     * a market is loaded in private.
     */
    async getCities(): Promise<City[]> {
        const response = await axiosInstance.get('/city/list/admin');
        return response.data;
    }

    async updateManuallyClosedStatus(locationId: number, isManuallyClosed: boolean) {
        await axiosInstance.patch(
            '/location/status',
            null,
            { params: { locationId, isManuallyClosed } }
        );
    }

    /**
     * Hide a restaurant from the customer catalogue, or bring it back.
     *
     * Separate from the closed status above and not part of the restaurant
     * update payload: hiding is one decision taken on its own, and an admin who
     * ticks the box expects it to take effect, not to wait for Save.
     *
     * Admin only on the server; a vendor's token is rejected.
     */
    async updateHiddenStatus(locationId: number, isHidden: boolean) {
        await axiosInstance.patch(
            '/location/hidden',
            null,
            { params: { locationId, isHidden } }
        );
    }
}